export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }).format(date);
};

export const formatCurrency = (val) => {
  if (typeof val === "number") {
    return new Intl.NumberFormat("th-TH", { style: "currency", currency: "THB", maximumFractionDigits: 0 }).format(val);
  }
  return val || "-";
};

export const getStatusBadgeConfig = (status) => {
  switch (status?.toLowerCase()) {
    case "new":
      return { label: "NEW", bg: "var(--status-new-bg)", color: "var(--status-new-text)" };
    case "qualified":
      return { label: "QUALIFIED", bg: "var(--status-qualified-bg)", color: "var(--status-qualified-text)" };
    case "contacted":
      return { label: "CONTACTED", bg: "var(--status-contacted-bg)", color: "var(--status-contacted-text)" };
    case "site_visit":
    case "site visit":
      return { label: "SITE VISIT", bg: "var(--status-site_visit-bg)", color: "var(--status-site_visit-text)" };
    case "proposal":
      return { label: "PROPOSAL", bg: "var(--status-proposal-bg)", color: "var(--status-proposal-text)" };
    case "leased":
      return { label: "LEASED", bg: "var(--status-leased-bg)", color: "var(--status-leased-text)" };
    case "lost":
      return { label: "LOST", bg: "var(--status-lost-bg)", color: "var(--status-lost-text)" };
    default:
      return { label: status?.toUpperCase() || "UNKNOWN", bg: "#F1F5F9", color: "#64748B" };
  }
};

export const getScoreColor = (score) => {
  if (score >= 85) return "#0D9488"; // High qualified - Teal
  if (score >= 70) return "#2563EB"; // Medium - Blue
  if (score >= 50) return "#D97706"; // Fair - Amber
  return "#DC2626"; // Low - Red
};

export const getChannelColor = (channel) => {
  switch (channel?.toLowerCase()) {
    case "facebook": return "#1877F2";
    case "google": return "#EA4335";
    case "tiktok": return "#000000";
    case "line": return "#06C755";
    case "website": return "#12B8A6";
    case "email": return "#6366F1";
    case "referral": return "#F5A623";
    default: return "#64748B";
  }
};
